export default "__VITE_ASSET__a1d954f5__"